export default "__VITE_ASSET__d6325102__"